module.exports = __webpack_public_path__ + "img/矩形896@2x.03e100b0.png";